import { handleError } from 'common/api/utils/handleError';
import { isApiError } from 'common/api/utils/isApiError';
import { showErrorMessage } from 'common/services/notification';
import { Credentials, useLogin } from 'features/auth/hooks';
import { StatusCodes } from 'http-status-codes';
import { FC } from 'react';
import { ForgotPasswordLink } from '../components/ForgotPasswordLink';
import HeaderBack from '../components/HeaderBack';
import { FormData, LogInForm } from '../components/LoginForm';
import { StyledContainer } from './styles';

export const LogInPage: FC = () => {
  const { login } = useLogin();

  const onSubmit = async (credentials: FormData) => {
    try {
      // Force type here because validation must have passed by now.
      await login(credentials as Credentials);
    } catch (error) {
      if (isApiError(error) && error.status === StatusCodes.UNAUTHORIZED) {
        showErrorMessage(
          'Unable to log in with the provided credentials, please try again.',
        );
      } else {
        // Component name passed because Sentry scrubs errors relating to auth
        handleError(
          error,
          'There was an issue logging in, please try again later.',
          'LogInPage',
        );
      }
    }
  };

  return (
    <StyledContainer>
      <HeaderBack title='Sign In' />
      <LogInForm onSubmit={onSubmit} />
      <ForgotPasswordLink />
    </StyledContainer>
  );
};
